import React, {useState} from 'react';
import {CssBaseline} from '@material-ui/core';
import Header from '../header';
import Sidebar from '../sidebar';
import {withStyles} from '@material-ui/core/styles';
import {styles, Classes} from '../styles';

interface OwnProps {
    children: React.ReactNode;
}

type IProps = Classes & OwnProps;

const Layout = (props: IProps) => {

    const {classes, children} = props;

    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            <Header onToggleSidebar={handleDrawerToggle}/>
            <Sidebar onToggleSidebar={handleDrawerToggle} mobileOpen={mobileOpen} />
            <main className={classes.content}>
                <div className={classes.toolbar} />
                {children}
            </main>
        </div>
    );
};

export default withStyles(styles)(Layout);
